import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';

import Item from '../Item/Item';

const ItemContainer = ({ file, rowIndex, droppableId, isDropDisabled }) => {
  return (
    <Droppable isDropDisabled={isDropDisabled} droppableId={droppableId}>
      {(provided, snapshot) => {
        let droppableContainerClasses = `filesListBody droppableContainer`;

        if (snapshot.draggingOverWith) {
          droppableContainerClasses += ' dropping ';
        }

        return (
          <div
            className={droppableContainerClasses}
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <Draggable
              key={`${file.id}`}
              draggableId={JSON.stringify(file)}
              index={rowIndex}
              isDragDisabled={false}
            >
              {(provided, snapshot) => (
                <Item
                  file={file}
                  snapshot={snapshot}
                  provided={provided}
                  isDropDisabled={isDropDisabled}
                />
              )}
            </Draggable>

            {provided.placeholder}
          </div>
        );
      }}
    </Droppable>
  );
};

export default ItemContainer;
